const repairLogProfile = {
  title: "REPAIR PROFILE",
  tag: "Asset TAG",
  type: "Asset Type",
  date: "Date Created",
  createdby: "Created By",
  log: "Log",
  deletebtn: "DELETE REPAIR TASK",
  backbtn: "Go Back"
};

export default repairLogProfile;
